export default __webpack_public_path__ + "static/media/emailIcon.842abad5.svg";